export default __webpack_public_path__ + "static/media/help-rav-v-2.c9dea935.png";